import * as React from "react";
import { LimitAndClosureScreens } from "../LimitsAndClosure/LimitsAndClosure";

// tslint:disable-next-line:no-var-requires
const styles = require("./LimitsAndClosureText.scss");

interface LimitsAndClosureTextProps {
    buttonText?: string;
    handleClick?: (e: React.BaseSyntheticEvent) => void;
    header: string;
    screen: string;
    text: string;
}

/* tslint:disable:jsx-no-multiline-js */
const LimitsAndClosureText = ({ ...props }: LimitsAndClosureTextProps) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>{props.header}</div>
            <div className={styles.text}>
                {props.text}
                {renderExclusionLink(props.screen) && (
                    <button
                        className={styles.exclusionLink}
                        value={buttonNavigationTarget(props.screen)}
                        onClick={props.handleClick}
                    >
                        {props.buttonText}
                    </button>
                )}
            </div>
        </div>
    );
};

const renderExclusionLink = (screenName: string) => {
    return (
        screenName === LimitAndClosureScreens.accountClosure ||
        screenName === LimitAndClosureScreens.exclusion
    );
};

const buttonNavigationTarget = (screenName: string) => {
    return screenName === LimitAndClosureScreens.accountClosure
        ? "ExclusionScreen"
        : "AccountClosureScreen";
};

export default LimitsAndClosureText;
